// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Ae","flex-start":"i_Af","flex-center":"i_Ag","title-wrapper":"i_Ah","subtitle":"i_Ai","icon":"i_Aj"};